import type { JSX } from 'react';
import { CircularProgress, Stack, Typography } from '@mui/material';
import { Outlet } from 'react-router-dom';

import { useAuth } from '../auth/AuthProvider';
import { CompanySelectionScreen } from './CompanySelectionScreen';

export function RequireCompany(): JSX.Element {
  const { isLoading, bootstrap } = useAuth();

  if (isLoading) {
    return (
      <Stack spacing={2} alignItems="center" justifyContent="center" sx={{ minHeight: '60vh' }}>
        <CircularProgress />
        <Typography color="text.secondary">Loading company context...</Typography>
      </Stack>
    );
  }

  if (!bootstrap || bootstrap.mode !== 'company') {
    return <CompanySelectionScreen />;
  }

  return <Outlet />;
}
